import React from "react";
import PropTypes from "prop-types";
import parse from "html-react-parser";

import styles from "./styles";

export const GuidesSection = ({ files }) => {
  const classes = styles();
  return (
    <section id="guide" className={classes.guideMainContainer}>
      <div className={classes.guideContent}>
        <div className={classes.rowContent}>
          <div className={classes.titleContainer}>
            <div className={classes.lineTitle} />
            <div className={classes.titleSection}>Guías</div>
          </div>
        </div>

        {files.map((file, index) => (
          <div key={index} className={classes.rowContent}>
            <div className={classes.subtitle}>{parse(file.fileName || "")}</div>
            <a
              href={`${file.url}`}
              target="_blank"
              rel="noreferrer"
              className={classes.buttonContainer}
            >
              Descargar PDF
            </a>
          </div>
        ))}
        <div className={classes.lineDivisor} />
      </div>
    </section>
  );
};

GuidesSection.propTypes = {
  files: PropTypes.any
};
